import { apiSlice } from "./apiSlice";

export const profileAccountApi = apiSlice.injectEndpoints({
  keepUnusedDataFor: 1,
  endpoints: (builder) => ({
    getMerchantProfile: builder.query({
      query: () => {
        return {
          url: "/merchant-dashboard/profile",
          method: "GET",
        };
      },
      transformResponse: (response, meta, arg) => response?.body,
      transformErrorResponse: (response, meta, arg) =>
        response?.data?.message ?? "Something went wrong please try again",
    }),

    getMerchantCommercialDataProfile: builder.query({
      query: () => {
        return {
          url: "/merchant-dashboard/commercial-profile",
          method: "GET",
        };
      },
      transformResponse: (response, meta, arg) => response?.body,
      transformErrorResponse: (response, meta, arg) =>
        response?.data?.message ?? "Something went wrong please try again",
    }),
    updateMerchantCommercialDataProfile: builder.mutation({
      query: (payload) => {
        return {
          url: "/merchant-dashboard/commercial-profile",
          method: "PATCH",
          body: { ...payload },
        };
      },
      transformErrorResponse: (response, meta, arg) =>
        response?.data?.message ?? "Something went wrong please try again",
    }),
    updateMerchantProfile: builder.mutation({
      query: (payload) => {
        return {
          url: "/merchant-dashboard/profile",
          method: "PUT",
          body: { ...payload },
        };
      },
      transformErrorResponse: (response, meta, arg) =>
        response?.data?.message ?? "Something went wrong please try again",
    }),
    updateMerchantPassword: builder.mutation({
      query: (payload) => {
        return {
          url: "/merchant-dashboard/update-password",
          method: "PUT",
          body: { ...payload },
        };
      },
      transformErrorResponse: (response, meta, arg) =>
        response?.data?.message ?? "Something went wrong please try again",
    }),
    updateProofOfDelivery: builder.mutation({
      query: (payload) => {
        return {
          url: "/merchant-dashboard/proofOfDelivery",
          method: "PUT",
          body: { ...payload },
        };
      },
      transformErrorResponse: (response, meta, arg) =>
        response?.data?.message ?? "Something went wrong please try again",
    }),
    updateMerchantById: builder.mutation({
      query: ({ id, payload }) => {
        return {
          url: `/merchant-dashboard/${id}`,
          method: "PUT",
          body: { ...payload },
        };
      },
      transformErrorResponse: (response, meta, arg) =>
        response?.data?.message ?? "Something went wrong please try again",
    }),
    getTransactions: builder.query({
      query: (params) => {
        return {
          url: "/transaction",
          method: "GET",
          params,
        };
      },
      transformResponse: (response, meta, arg) => response?.body,
      transformErrorResponse: (response, meta, arg) =>
        response?.data?.message ?? "Something went wrong please try again",
    }),
    getMottasl: builder.query({
      query: () => {
        return {
          url: "/mottasl/all",
          method: "GET",
        };
      },
      transformResponse: (response, meta, arg) => response?.body,
      transformErrorResponse: (response, meta, arg) =>
        response?.data?.message ?? "Something went wrong please try again",
    }),
  }),
});

export const {
  useGetMerchantProfileQuery,
  useUpdateMerchantCommercialDataProfileMutation,
  useUpdateMerchantPasswordMutation,
  useUpdateProofOfDeliveryMutation,
  useUpdateMerchantByIdMutation,
  useGetTransactionsQuery,
  useGetMottaslQuery,
  useUpdateMerchantProfileMutation,
  useGetMerchantCommercialDataProfileQuery
} = profileAccountApi;
